"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UberTripOutput = exports.UberWaypoint = exports.UberProduct = exports.UberLocation = exports.UberVehicle = exports.UberDriver = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class UberDriver {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UberDriver.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UberDriver.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UberDriver.prototype, "phone", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UberDriver.prototype, "phoneForSms", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], UberDriver.prototype, "note", void 0);
exports.UberDriver = UberDriver;
class UberVehicle {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UberVehicle.prototype, "brand", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UberVehicle.prototype, "model", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UberVehicle.prototype, "color", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UberVehicle.prototype, "licensePlate", void 0);
exports.UberVehicle = UberVehicle;
class UberLocation {
}
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], UberLocation.prototype, "lat", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], UberLocation.prototype, "lng", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], UberLocation.prototype, "bearing", void 0);
exports.UberLocation = UberLocation;
class UberProduct {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UberProduct.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UberProduct.prototype, "name", void 0);
exports.UberProduct = UberProduct;
class UberWaypoint {
    constructor(lat, lng, type) {
        this.lat = lat;
        this.lng = lng;
        this.type = type;
    }
}
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], UberWaypoint.prototype, "lat", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], UberWaypoint.prototype, "lng", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UberWaypoint.prototype, "type", void 0);
exports.UberWaypoint = UberWaypoint;
class UberTripOutput {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UberTripOutput.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)([
        'processing',
        'no_drivers_available',
        'accepted',
        'arriving',
        'in_progress',
        'driver_canceled',
        'rider_canceled',
        'completed',
        'scheduled',
        'failed',
        'offered',
        'expired',
        'driver_redispatched',
        'ready',
    ]),
    __metadata("design:type", String)
], UberTripOutput.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], UberTripOutput.prototype, "surge", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], UberTripOutput.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => UberProduct),
    __metadata("design:type", UberProduct)
], UberTripOutput.prototype, "product", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => UberDriver),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", UberDriver)
], UberTripOutput.prototype, "driver", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => UberVehicle),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", UberVehicle)
], UberTripOutput.prototype, "vehicle", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => UberLocation),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", UberLocation)
], UberTripOutput.prototype, "location", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => UberWaypoint),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], UberTripOutput.prototype, "waypoints", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], UberTripOutput.prototype, "pickUpAt", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], UberTripOutput.prototype, "dropOffAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UberTripOutput.prototype, "requesterName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UberTripOutput.prototype, "requesterId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], UberTripOutput.prototype, "price", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UberTripOutput.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UberTripOutput.prototype, "comment", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], UberTripOutput.prototype, "runId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], UberTripOutput.prototype, "distance", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], UberTripOutput.prototype, "duration", void 0);
exports.UberTripOutput = UberTripOutput;
